<template>
  <div class="mb-3 sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg">
    <div
      @click="goToActionUrl()"
      class="bg-white rounded-lg border border-gray-200 shadow-sm p-4 relative overflow-hidden transition-all duration-200 hover:shadow-md"
      :class="{
        '!bg-gray-100 !border-gray-300': isLoggedIn && notification.user_read,
        '!bg-white !border-gray-200': isLoggedIn && !notification.user_read,
        'cursor-pointer hover:border-primary-community' : notification.action_url
      }"
    >
      <!-- Colored ribbon indicator -->
      <div class="absolute top-0 left-0 w-1 h-full" :style="notificationColor(notification.type)"></div>

      <!-- Main Content -->
      <div class="tw-flex items-center justify-between">
        <div class="tw-flex items-center flex-1 min-w-0">
          <!-- Icon -->
          <div class="flex-shrink-0 mr-3">
            <div class="w-6 h-6 rounded-full tw-flex items-center justify-center"
                 :class="notificationColorClass(notification.type)"
                 :style="{ backgroundColor: notificationColor(notification.type).backgroundColor }"
            >
              <icon
                :class="'w-3 h-3 text-white'"
                :name="notificationIconName(notification.type, notification.event)"
              />
            </div>
          </div>

          <!-- Content -->
          <div class="flex-1 min-w-0 tw-flex flex-row">
            <!-- Title and read status -->
            <div class="tw-flex flex-col items-left">
              <div class="tw-flex items-center gap-2 mb-1 flex-row">
                <h3 class="text-sm font-medium text-gray-900 truncate" v-if="notification.title">
                  {{ notification.title }}
                </h3>
                <!-- Read Status Tag -->
                <span
                  v-if="isLoggedIn && notification.user_read == false"
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                >
                New
              </span>
                <span
                  v-if="isLoggedIn && notification.user_read == true"
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                >
              Read
              </span>
              </div>

              <!-- One-line description -->
              <p class="text-sm text-gray-600 truncate" v-if="notification.body">
                {{ stripHtmlAndTruncate(notification.body, 80) }}
              </p>
            </div>
          </div>
          <!-- Metadata -->
          <div class="items-center text-xs text-gray-500 mt-1">
            <time :title="notification.created_at">
              {{ toDateStringTranslated(notification.created_at) }}
            </time>
            <!--              <span v-if="$store.getters.isOwner && displayRole(notification)" class="ml-2">
                            • {{ displayRole(notification) }}
                          </span>-->
          </div>
        </div>

        <!-- Edit button -->
        <div class="flex-shrink-0 ml-3">
          <ds-button
            v-if="canEditAnnouncement(notification)"
            variant="outline"
            size="small"
            icon="edit"
            @click="$parent.edit(notification)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { timeAgo, toDateStringTranslated } from '../../util/date'

  import { notificationColor, notificationColorClass, notificationIconName } from '../../util/NotificationsMixin'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui'
  import MODAL_IDS from '../../constants/modal-ids'

  import DsTextarea from '../Form/DsTextarea.vue'
  import Avatar from '../Avatar/Avatar.vue'
  import Card from '../Card/Card.vue'
  import TranslationsMixin from '../../util/TranslationsMixin.js'

  export default {
    name: 'notification-detail',
    props: ['notification'],
    data () {
      return {
        errors: {},
      }
    },
    methods: {
      timeAgo,
      toDateStringTranslated,
      notificationColor,
      notificationColorClass,
      notificationIconName,
      stripHtmlAndTruncate (html, maxLength = 80) {
        if (!html) return ''
        // Remove HTML tags
        const text = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        // Truncate to max length
        if (text.length <= maxLength) return text
        return text.substring(0, maxLength) + '...'
      },
      /*displayRole (item) {
        if (!item.event || item.type != 'announcement') {
          return
        }

        switch (item.event) {
          case 'all':
            return ' Targetted at every user.'
          case 'owner':
            return ' Targetted at owners.'
          case 'member':
            return ' Targetted at every team member.'
          case 'actor':
            return ' Targetted at ecosystem members.'
        }
      },*/
      canEditAnnouncement (notification) {
        if (!this.isLoggedIn) {
          return false
        }

        if (!notification.type || notification.type != 'announcement') {
          return false
        }

        if (notification.type == 'announcement' && notification.event != 'public') {
          return false
        }

        if (this.isDeveloper) {
          return true
        }

        if (this.$store.getters.ownedTeams.find(t => t.id === notification.ecosystem_id)) {
          return true
        }
      },
      openSidepanel (actorID) {
        this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, { component: 'scores', metaData: actorID })
      },
      goToActionUrl () {
        var url = this.notification.action_url
        var eventType = this.notification.event

        if (!url) {
          return
        }

        var index = eventType.indexOf('report')
        if (index > -1 && !url.endsWith('#reports')) {
          window.location.href = url + '#reports'
        }
        window.location.href = url
      },
      notificationLinkValidation (url, eventType) {
        // If the notification is of the "report" type, when redirecting to the reports tab of actor profile we add the "#reports" parameter so that
        // the tab component detects that parameter and opens the correct tab, in this case the reports tab.
        // Else its redirected to the normal URL with no parameter.
        var index = eventType.indexOf('report')
        if (index > -1 && !url.endsWith('#reports')) {
          return url + '#reports'
        }
        return url
      },
      showLoginModal () {
        this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.LOGIN)
      },
    },
    computed: {
      notificationContext () {
        return this.notification.context
      },
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
    },
    mixins: [TranslationsMixin],
    components: {
      DsTextarea,
      Avatar,
      Card,
    },
  }
</script>

<style scoped>
  /* Additional styles for prose content */
  .prose :deep(ul), .prose :deep(ol) {
    @apply ml-4;
  }

  .prose :deep(p) {
    @apply text-sm leading-relaxed;
  }

  .prose :deep(a) {
    @apply text-primary hover:text-primary transition-colors duration-200;
  }

  /* Line clamp utility */
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>
